// extracted by mini-css-extract-plugin
export default {"review":"ReviewProducts_review__oYozd","card":"ReviewProducts_card__tVfee"};